import { createContext, useContext } from 'react'
import type { RoleMembre } from '../api/types'
import type { FixturesAlertes } from '../api/alertes'
import type { FixturesMessagerie } from '../api/messagerieClients'
import { peut, refus, type Capacite } from '../api/roles'

/**
 * Le rôle de la personne connectée, lu UNE fois à la résolution d'accès
 * (`memberships.role`). Les écrans s'en servent pour ne pas proposer un bouton
 * que la base refuserait — la base, elle, reste juge en dernier ressort.
 */
export interface ContexteConsole {
  role: RoleMembre | null
  /** Aperçu de développement : données fictives, aucune écriture possible. */
  apercu: boolean
  /** Alertes, zones et journal de commandes FICTIFS de l'aperçu (0052) ; `null` hors aperçu. */
  fixturesAlertes?: FixturesAlertes | null
  /** Messages FICTIFS de l'aperçu (0067) ; `null` hors aperçu. */
  fixturesMessagerie?: FixturesMessagerie | null
}

export const Contexte = createContext<ContexteConsole>({ role: null, apercu: false, fixturesAlertes: null, fixturesMessagerie: null })

export function useDroits() {
  const { role, apercu, fixturesAlertes = null, fixturesMessagerie = null } = useContext(Contexte)
  return {
    role,
    apercu,
    fixturesAlertes,
    fixturesMessagerie,
    peut: (c: Capacite) => peut(role, c),
    refus: refus(role),
  }
}
